// src/pages/design/Fcn_view.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MobileFormViewManager from "../../components/common/mobile/MobileFormViewManager";
import MobileShareButton from "../../components/common/mobile/MobileShareButton";
import PeopleView from "../../components/common/people/PeopleView";
import TinyMCEpreview from "../../components/const/TinyMCEpreview";
import { getDocPersons } from "../../api/papers";
import { changeDocState } from "../../api/design/meta"; // 🔹 state 변경 API

export default function Fcn_view() {
  const { id: project, dns } = useParams();

  return (
    <div className="mobile-page-root mb-16">
      <div className="mobile-page-root-inner">
        <MobileFormViewManager
          params={{
            module: "design",
            doc_type: "FCN",
            project,
            dns,
          }}
          doc_name={"설계변경통보서"}
        >
          <FcnViewContent dns={dns} />
        </MobileFormViewManager>
      </div>
    </div>
  );
}

function FcnViewContent({ meta, data, dns }) {
  const navigate = useNavigate();
  const { id: project } = useParams();

  const columns = [
    { key: "no", header: "No", width: "60px", align: "center" },
    { key: "item", header: "항목" },
    { key: "before", header: "변경 전 내용" },
    { key: "after", header: "변경 후 내용" },
    { key: "note", header: "비고" },
  ];

  const rows = (meta?.details || []).map((r, i) => ({
    no: i + 1,
    ...r,
  }));

  const me = JSON.parse(localStorage.getItem("user") || "null");
  const myUserId = me?.id || me?.user?.id;

  const [people, setPeople] = useState([]);

  // ▸ FCN 문서 state/status
  const docState =
    data?.state ?? meta?.state ?? data?.status ?? meta?.status ?? null;

  useEffect(() => {
    const loadPeople = async () => {
      try {
        const list = await getDocPersons(dns);
        setPeople(list || []);
      } catch (error) {
        console.error("담당자 로드 오류:", error);
        setPeople([]);
      }
    };
    loadPeople();
  }, [dns]);

  // ▸ 담당자인지 여부
  const isAssignee = people.some(
    (p) => p.id === myUserId || p.userId === myUserId || p.user_id === myUserId
  );

  // ▸ 버튼 노출 조건: 담당자 + save 상태
  const canCreateDCN = isAssignee && docState === "save";
  const canReject = isAssignee && docState === "save";

  const handleGoToDCN = () => {
    const baseProject = data?.project || project || "-";
    const baseDns = data?.doc_dns || dns;

    navigate(`/project/${baseProject}/design/dcn/new?fromFCN=${baseDns}`);
  };

  const handleReject = async () => {
    if (!window.confirm("FCN 요청을 반려하시겠습니까?")) return;
    try {
      await changeDocState(dns, "reject");
      alert("요청이 반려되었습니다.");
      window.location.reload();
    } catch (e) {
      console.error(e);
      alert("반려 처리 중 오류가 발생했습니다.");
    }
  };

  const sectionStyle = "rounded-lg border bg-white p-3 min-w-0 w-full";
  const sectionStyleObj = { width: '100%', maxWidth: '100%', boxSizing: 'border-box' };

  return (
    <div className="mobile-page-root mb-16">
      <div className="mobile-page-root-inner space-y-3">
        {/* 통보 정보 */}
        <section className={sectionStyle} style={sectionStyleObj}>
          <div className="text-sm font-semibold mb-4 text-gray-900">통보 정보</div>

          <div className="space-y-4 min-w-0 w-full">
            {/* 통보 담당자 */}
            <div className="flex flex-col gap-1.5 min-w-0 w-full border-b border-gray-100 pb-3">
              <div className="text-xs text-gray-600 font-medium">통보 담당자</div>
              <div className="text-sm text-gray-900 break-words leading-relaxed">
                <PeopleView dns={dns} placeholder="지정된 담당자 없음" />
              </div>
            </div>

            {/* 변경 사유 */}
            {meta?.reason && (
              <div className="flex flex-col gap-1.5 min-w-0 w-full border-b border-gray-100 pb-3">
                <div className="text-xs text-gray-600 font-medium">변경 사유</div>
                <div className="text-sm text-gray-900 break-words leading-relaxed min-w-0 w-full">
                  <TinyMCEpreview html={meta.reason} />
                </div>
              </div>
            )}

            {/* 연결된 FCR 문서 */}
            {meta?.related_doc && (
              <div className="flex flex-col gap-1.5 min-w-0 w-full">
                <div className="text-xs text-gray-600 font-medium">연결된 FCR 문서</div>
                <div className="text-sm text-gray-900 break-words leading-relaxed">{meta.related_doc || "-"}</div>
              </div>
            )}
          </div>
        </section>

        {/* 변경 항목 내역 */}
        <section className={sectionStyle} style={sectionStyleObj}>
          <div className="text-sm font-semibold mb-4 text-gray-900">변경 항목 내역</div>
          <div className="space-y-3 min-w-0 w-full">
            {rows.length > 0 ? (
              rows.map((r, idx) => {
                const fileUrl =
                  r.drawingFileUrl ||
                  (r.drawingFileId
                    ? `/project/${project}/design/library/doc/${r.drawingFileId}`
                    : null);

                return (
                  <div key={r.no || idx} className="border border-gray-200 rounded-lg p-3 bg-gray-50 space-y-2 min-w-0 w-full">
                    <div className="flex items-center gap-2">
                      <span className="text-xs font-medium text-gray-600">No.</span>
                      <span className="text-sm font-semibold text-gray-900">{r.no}</span>
                    </div>
                    <div className="flex flex-col gap-1.5">
                      <div className="text-xs text-gray-600 font-medium">항목</div>
                      <div className="text-sm text-gray-900 break-words">
                        {fileUrl ? (
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 underline hover:text-blue-700"
                          >
                            {r.item || "도면보기"}
                          </a>
                        ) : (
                          <span>{r.item || "-"}</span>
                        )}
                      </div>
                    </div>
                    <div className="flex flex-col gap-1.5">
                      <div className="text-xs text-gray-600 font-medium">변경 전 내용</div>
                      <div className="text-sm text-gray-900 break-words">{r.before || "-"}</div>
                    </div>
                    <div className="flex flex-col gap-1.5">
                      <div className="text-xs text-gray-600 font-medium">변경 후 내용</div>
                      <div className="text-sm text-gray-900 break-words">{r.after || "-"}</div>
                    </div>
                    {r.note && (
                      <div className="flex flex-col gap-1.5">
                        <div className="text-xs text-gray-600 font-medium">비고</div>
                        <div className="text-sm text-gray-900 break-words">{r.note}</div>
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="text-center text-sm text-gray-400 py-4">
                변경 항목 내역이 없습니다.
              </div>
            )}
          </div>
        </section>

        {/* 연결 문서 안내 */}
        {meta?.related_doc && (
          <section className={sectionStyle} style={sectionStyleObj}>
            <div className="text-xs text-gray-500 italic">
              ※ 본 통보서는 FCR ({meta.related_doc}) 문서를 기반으로 작성되었습니다.
            </div>
          </section>
        )}

        {/* 액션 버튼 영역 - 통보 정보와 첨부자료 사이 */}
        {(canCreateDCN || canReject) && (
          <section className={`${sectionStyle} no-print`} style={sectionStyleObj}>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full">
              {canCreateDCN && (
                <button
                  onClick={handleGoToDCN}
                  className="btn-create text-sm px-4 py-2.5 flex-1 sm:flex-initial flex-shrink-0 whitespace-nowrap"
                >
                  + 변경도면 작성 (DCN)
                </button>
              )}
              {canReject && (
                <button
                  onClick={handleReject}
                  className="btn-delete text-sm px-4 py-2.5 flex-1 sm:flex-initial flex-shrink-0 whitespace-nowrap"
                >
                  반려
                </button>
              )}
              <MobileShareButton
                title={`설계변경통보서 (FCN)`}
                className="flex-shrink-0"
              />
            </div>
          </section>
        )}
      </div>
    </div>
  );
}
